import React, { useMemo } from "react";
import { RCCAlert, RCCGrid, RCCHidden } from "react-common-components";
import { v4 } from "uuid";
import { useTranslation } from "src/context/Translations/context";
import { IComponentList } from "./interface";

import Container, { StyledSpan} from "./styles";
import InfiniteScrollWithoutFetch from "../InfiniteScrollWithoutFetch";
import Column from "./column";

export const getStyles = (truncate?: boolean) => {
	const styleObj: any = truncate ? {
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		overflow: "hidden"
	} : {};
	
	styleObj.height = "100%";

	return styleObj;
};

const List: React.FC<IComponentList> = ({
	data,
	columns,
	showHeader,
	layout,
	styleInline,
	headerHiddenXs = true,
	defaultNumberOfElements,
	manuallyToggleShowMore,
	filter,
	childrenOfLine,
	onClickLi
}) => {

	const { translate } = useTranslation();

	const ListElements = useMemo(() => (
		<InfiniteScrollWithoutFetch
			listElements={data}
			filter={filter}
			defaultNumberOfElements={defaultNumberOfElements}
			manuallyToggleShowMore={manuallyToggleShowMore}
			mapper={(dt: any, index) => (
				<React.Fragment key={v4()}>
					<li className="list-component-child" onClickCapture={() => onClickLi && onClickLi(dt)}>
						{columns.map((column) => (
							<Column 
								key={v4()}
								dt={dt}
								index={index || 0}
								column={column}
							/>
						))}
					</li>
					{childrenOfLine && childrenOfLine.conditionToRender(dt) && (
						<li className="list-component-child is-children" onClickCapture={() => onClickLi && onClickLi(dt)}>
							{childrenOfLine.cellRenderer(dt)}
						</li>
					)}
				</React.Fragment>
			)}
		/>
	), [data, filter]);

	const Header = useMemo(() => {
		if(!showHeader || (filter && data.filter(filter).length === 0))
			return null;

		return(
			<RCCHidden only={headerHiddenXs ? "xs" : undefined}>
				<li className="list-component-header">
					{columns.filter((column) => !column.hideHeader).map((column) => (
						<RCCHidden key={v4()} only={column.hidden}>
							<RCCGrid
								item
								container
								alignItems="center"
								xs={column.xs}
								sm={column.sm}
								md={column.md}
								lg={column.lg}
								justifyContent={
									column.justify === "left" && "flex-start" ||
								column.justify === "right" && "flex-end" ||
								"center"
								}
								style={getStyles(column.truncate)}
								styleInline={column.styleInline}
							>
								{column.customHeader ? column.customHeader(data) : (
									<StyledSpan
										truncate={column.truncate}
										bold
									>
										{column.nameColumn}
									</StyledSpan>
								)}	
							</RCCGrid>
						</RCCHidden>
					))}
				</li>
			</RCCHidden>
		);
	}, [data, filter]);

	return (
		<Container 
			className="class-to-export-list-component-of-score"
			styleInline={styleInline}
			layout={layout}
		>
			{!data || data.length === 0 ? (
				<RCCAlert 
					title={translate("Atenção")}	
					description={translate("Não foram encontrados resultados para esta pesquisa")}
				/>
			): (
				<>
					{Header}
					{ListElements}
				</>
			)}
		</Container>);
};

export default List;
